import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { useEffect, useState } from 'react';

import QuestionListModuleCss from './QuestionList.module.css';
import { LocalizedText } from '~/components/LocalizedText/LocalizedText';
import { QuestionItem } from '~/components/QuestionItem/QuestionItem';
import { LocalizationItem, MAX_AMOUNT_ITEMS_TO_RENDER } from '~/constants';
import type { Question } from '~/models/supportCenter';

const block = bemCssModules(QuestionListModuleCss);

interface QuestionListProps {
  questionList: Question[];
  isShowMoreEnabled: boolean;
  truncate?: number;
}

export const QuestionList: VFC<QuestionListProps> = ({
  questionList,
  isShowMoreEnabled,
  truncate,
}) => {
  const [questionListToRender, setQuestionListToRender] = useState(questionList);

  const [amountItemsToRender, setAmountItemsToRender] = useState(MAX_AMOUNT_ITEMS_TO_RENDER);

  const handleShowMore = () => {
    if (!(questionList.length === questionListToRender.length)) {
      const itemsToRender = amountItemsToRender + MAX_AMOUNT_ITEMS_TO_RENDER;
      setAmountItemsToRender(itemsToRender);
      setQuestionListToRender(questionList.slice(0, itemsToRender));

      return;
    }

    setAmountItemsToRender(MAX_AMOUNT_ITEMS_TO_RENDER);
    setQuestionListToRender(questionList.slice(0, MAX_AMOUNT_ITEMS_TO_RENDER));
  };

  const getLocalizationItem = () => {
    if (questionList.length === questionListToRender.length) {
      return LocalizationItem.Hide;
    }

    return LocalizationItem.ShowMore;
  };

  useEffect(() => {
    let preparedList = [];
    if (isShowMoreEnabled && questionList.length > MAX_AMOUNT_ITEMS_TO_RENDER) {
      preparedList = questionList.slice(0, MAX_AMOUNT_ITEMS_TO_RENDER);
    } else {
      preparedList = questionList;
    }
    setQuestionListToRender(preparedList);
  }, [questionList, isShowMoreEnabled]);

  let loadMoreButton = null;
  if (isShowMoreEnabled && questionList.length > MAX_AMOUNT_ITEMS_TO_RENDER) {
    loadMoreButton = (
      <button
        type="button"
        className={block('button')}
        onClick={handleShowMore}
      >
        <LocalizedText localizationItem={getLocalizationItem()} />
      </button>
    );
  }

  return (
    <div className={block()}>
      {questionListToRender.map((questionItem) => (
        <QuestionItem
          key={questionItem.Question}
          questionItem={questionItem}
          truncate={truncate}
        />
      ))}
      {loadMoreButton}
    </div>
  );
};
